import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function safeNext(value) {
  if (!value || typeof value !== "string") return "/admin";
  if (!value.startsWith("/")) return "/admin";
  if (value.startsWith("//")) return "/admin";
  if (value.startsWith("/login")) return "/admin";
  return value;
}

async function readJson(res) {
  const text = await res.text();
  if (!text.trim()) return {};
  try {
    return JSON.parse(text);
  } catch (_) {
    throw new Error(`Expected JSON, got: ${text.slice(0, 180)}`);
  }
}

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [remember, setRemember] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const next = safeNext(new URLSearchParams(location.search).get("next"));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("/api/login.php", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await readJson(res);
      if (res.ok && data.success) {
        if (remember) localStorage.setItem("rememberMe", "true");
        else localStorage.removeItem("rememberMe");
        navigate(next, { replace: true });
      } else {
        setError(data.error || "Login failed");
      }
    } catch (err) {
      setError(err.message || "Login failed");
    }
  };

  useEffect(() => {
    let cancelled = false;
    fetch("/api/session.php", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(readJson)
      .then((data) => {
        if (!cancelled && data.authenticated) navigate(next, { replace: true });
      })
      .catch((err) => {
        console.error("Session check failed:", err);
      });
    return () => {
      cancelled = true;
    };
  }, [navigate, next]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-950 px-4 text-white">
      <form onSubmit={handleSubmit} className="bg-white/10 border border-cyan-400/20 backdrop-blur p-6 rounded-3xl shadow-2xl w-full max-w-sm">
        <div className="flex justify-center mb-4">
          <img src="/logo.png" alt="Site Logo" className="h-12" />
        </div>
        <h2 className="text-2xl font-semibold text-center mb-4">Admin Login</h2>
        {error && <p className="rounded-lg border border-red-300/30 bg-red-500/10 text-red-100 text-sm mb-4 px-3 py-2">{error}</p>}
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full p-2 mb-3 border border-white/20 rounded bg-white text-slate-950"
          autoComplete="username"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full p-2 mb-3 border border-white/20 rounded bg-white text-slate-950"
          autoComplete="current-password"
          required
        />
        <label className="flex items-center text-sm mb-4 text-slate-200">
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="mr-2" />
          Remember Me
        </label>
        <button type="submit" className="w-full bg-cyan-500 text-slate-950 font-semibold py-2 rounded hover:bg-cyan-400">
          Login
        </button>
      </form>
    </div>
  );
}
